import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";

interface MyTimesheetDateComponentProps {
  label: string;
  date?: string;
  time?: string;
  hideContent?: boolean;
  width?: string;
  isMobile?: boolean;
}

export const MyTimesheetDateComponent: React.FC<
  MyTimesheetDateComponentProps
> = ({ label, date, time, hideContent, width, isMobile }) => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      height="60px"
      padding="16px"
      style={{
        backgroundColor: theme.palette.gray30.main,
        borderRadius: "4px",
      }}
    >
      <Typography
        variant="body1"
        style={{
          color: theme.palette.owGray.main,
        }}
      >
        {label}
      </Typography>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="center"
        style={{
          borderTop: `1px solid ${theme.palette.gray40.main}`,
          paddingTop: "8px",
          marginTop: "4px",
          width: isMobile ? "auto" : width ? width : "320px",
        }}
      >
        {!hideContent && (
          <>
            <Box display="flex" flexDirection="column" alignItems="center">
              <Typography variant="h6">{date}</Typography>
            </Box>
            <Box width="48px" />
            <Box display="flex" flexDirection="column" alignItems="center">
              <Typography variant="h6">{time}</Typography>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

MyTimesheetDateComponent.propTypes = {
  label: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
};

export default MyTimesheetDateComponent;
